/* eslint-disable prettier/prettier */
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Airports, AirportModel } from '@models/index';

export default class PNRValidation {
  static PNRmatch(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { pnr: { value: control.value, msg: 'format error' } };
      }

      const raw = control.value.toString();

      if (/\s/.test(raw)) {
        return { pnr: { value: control.value, msg: 'spaces not allowed' } };
      }

      const upperValue = raw.toUpperCase();
      const regexPNR = new RegExp(/^[A-Z0-9]{6}$/);
      const regTicket = new RegExp(/^[0-9]{13}$/);

      if (regexPNR.test(upperValue)) {
        if (PNRValidation.matchesAirportOrCity(upperValue)) {
          return { pnr: { value: control.value, msg: 'matches airport or city' } };
        }
        return null;
      }

      if (regTicket.test(raw)) {
        return null;
      }

      return { pnr: { value: control.value, msg: 'format error' } };
    };
  }

  static matchesAirportOrCity(value: string): boolean {
    const airports = Airports.getAirports();
    if (!airports || airports.length === 0) return false;

    const normalized = value
      .toUpperCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    return airports.some((airport: AirportModel) => {
      if (airport.code && airport.code.toUpperCase() === normalized) return true;

      const cityNames = [
        airport.es_MX,
        airport.en_US,
        airport.fr_FR,
        airport.ja_JP,
        airport.kr_KR,
        airport.zh_CN,
        airport.du_NL,
        airport.pt_PT,
      ];

      return cityNames.some((name) => {
        if (!name) return false;
        const normalizedCity = name
          .toUpperCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim();
        return normalizedCity === normalized;
      });
    });
  }

  static onlyLetters(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null; // Validators.required maneja el caso vacío

      const value = control.value.toString();
      // Permitir letras, espacios, apóstrofes y guiones
      const regex = /^[a-zA-Z\s'-]+$/;
      // Debe contener al menos una letra: no se permite un valor de solo espacios
      const hasLetter = /[a-zA-Z]/.test(value);

      if (value.trim().length === 0 || !hasLetter || !regex.test(value)) {
        return { lastName: { value: control.value, msg: 'only letters allowed' } };
      }

      return null;
    };
  }

  static prepareForComparison(value: string): string {
    return value.trim().toUpperCase();
  }
}
